import React from 'react';
import formatDate from 'date-fns/format';
import { Time } from './Time';

interface DateFormatProps {
  /**
   * The date string to be displayed. Can be any valid date string parseable by Date.parse().
   */
  date: string;

  /**
   * The format string to use for formatting the date. Uses date-fns v1 format tokens.
   * Examples: 'MM/DD/YYYY', 'MMMM D, YYYY', 'YYYY-MM-DD HH:mm:ss'
   */
  format: string;

  /**
   * Optional CSS class name to apply to the time element.
   */
  className?: string;
}

/**
 * DateFormat component for displaying a date in a custom format.
 * Uses date-fns format function to format the date.
 * @param props The component props.
 * @returns JSX.Element
 */
export const DateFormat: React.FC<DateFormatProps> = ({
  date,
  format: formatString,
  className,
}) => {
  const timestamp = Date.parse(date);
  const dateObject = new Date(timestamp);
  const formattedDate = formatDate(dateObject, formatString);

  return (
    <Time date={date} className={className}>
      {formattedDate}
    </Time>
  );
};
